import React from 'react';
import { Section } from './Section';
import { SocialButton } from './SocialButton';
import { Instagram, Linkedin, MessageCircle, Bell } from 'lucide-react';
import { motion } from 'framer-motion';
export function Contact() {
  return <Section id="contact" title="Get In Touch" data-id="element-33">
      <div className="max-w-4xl mx-auto text-center" data-id="element-34">
        <motion.p className="text-xl text-gray-600 mb-8" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-35">
          Let's connect and explore how we can work together to create
          transformative learning experiences.
        </motion.p>
        <motion.div className="flex flex-wrap gap-4 justify-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-36">
          <SocialButton href="https://wa.me/2348127476613" label="Message on WhatsApp" icon={<MessageCircle size={18} data-id="element-38" />} primary data-id="element-37" />
          <SocialButton href="https://linkedin.com/in/andrewigbineweka" label="LinkedIn" icon={<Linkedin size={18} data-id="element-40" />} data-id="element-39" />
          <SocialButton href="https://instagram.com/andrewigbineweka" label="Instagram" icon={<Instagram size={18} data-id="element-42" />} data-id="element-41" />
          <SocialButton href="https://www.linkedin.com/newsletters/the-networking-salon-%25F0%259F%2593%25A3-6970049734086377472/" label="Newsletter" icon={<Bell size={18} data-id="element-44" />} data-id="element-43" />
        </motion.div>
        <motion.div className="mt-20 text-sm text-gray-500" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-45">
          <p data-id="element-46">
            © {new Date().getFullYear()} Andrew Igbineweka. All rights
            reserved.
          </p>
        </motion.div>
      </div>
    </Section>;
}